import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Page, Header } from 'components';
import { CapacityPRBBlackListForm } from './components';
import { SetFormState } from '../actions/CapacityPRBBlackListActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	sitelist: {
		marginTop: theme.spacing(6)
	}
}));

const CapacityPRBBlackListExport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.TopOffendersWorstSitesReducers.formState);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				subRegion: '',
				startDate: null,
				days: '7',
				Occorrencyvalue: '80',
			},
			touched: {
				...formState.touched,
				site: false
			}
		});
	}, []);

	return (
		<Page className={classes.root} title="Top Offenders">
			<Header module="Top Offenders" view="Capacity PRB Black List" />
			<CapacityPRBBlackListForm />
		</Page>
	);
};

export default CapacityPRBBlackListExport;
